
import React from 'react';
import DoubleBedsheetImage from '../images/double-bedsheet.jpg';
import './DoubleBedsheetDetail.css';

function DoubleBedsheetDetail() {
    return (
        <div className="double-bedsheet-detail">
            <h1>White Fitted Double Bedsheet - Luxurious Comfort</h1>
            <img src={DoubleBedsheetImage} alt="Luxurious white fitted double bedsheet" />
            <h2>Detailed Description</h2>
            <p>Premium White Fitted Double Bedsheets – Soft, Durable & Perfectly Tailored for a Luxurious Sleep
               Upgrade your sleep experience with our luxury white fitted double bedsheets, designed for unmatched 
               comfort, style, and durability. Crafted from high-quality, hypoallergenic fabric, these bedsheets are gentle 
               on sensitive skin and perfect for allergy sufferers. The snug, secure fit ensures your bed always looks neat 
               and feels smooth — no bunching or slipping.

               Featuring a sleek, minimalist design, our bedsheets add a touch of timeless elegance to any bedroom décor. 
               Whether you're refreshing your home or stocking your guest room, enjoy a perfect balance of softness, 
               breathability, and long-lasting wear.

               ✅ Hypoallergenic & skin-friendly
               ✅ Deep pockets for a perfect fit
               ✅ Easy to wash, quick to dry
               ✅ Designed for everyday luxury

               Transform your bed into a haven of comfort—shop now and experience the difference.
            </p>
        </div>
    );
}

export default DoubleBedsheetDetail;




